<template>
    <div class="search-box">
        <el-select
            class="select"
            :class="{
                group: newSelect,
                fontLen3: groupName.length === 3,
                fontLen4: groupName.length === 4,
                fontLen5: groupName.length === 5,
                fontLen6: groupName.length === 6,
            }"
            popper-class="group-select"
            v-model="newSelect"
            placeholder="请选择"
            :filterable="true"
            :clearable="true"
            @focus="setSendKeyBoardToCocos({key: 'selectSubject', value: false})"
            @blur="setSendKeyBoardToCocos({key: 'selectSubject', value: true})"
        >
            <span slot="prefix">{{groupName?`${groupName} |`:''}}</span>
            <el-option-group
                    v-for="group in options"
                    :key="group.label"
                    :label="group.label"
            >
                <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-option-group>
        </el-select>
        <el-input
            prefix-icon="el-icon-search"
            class="search-value"
            v-model="newContent"
            placeholder="搜索知识点、关键词"
            :clearable="true"
            @focus="setSendKeyBoardToCocos({key: 'searchValue', value: false})"
            @blur="setSendKeyBoardToCocos({key: 'searchValue', value: true})"
        ></el-input>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {options} from "./subject";
    import * as CommonServer from '../../../../../../../../api/common'

    export default {
        name: "search-box",
        props: {
            select: [Number, String],
            content: String
        },
        watch: {
            select(vl){
                this.newSelect = vl
            },
            newSelect(vl){
                this.$emit('update:select', vl)
                const arr = vl.split('/')
                this.setSelectedSubject(arr[0], arr[1])
            },
            content(vl){
                this.newContent = vl
            },
            newContent(vl){
                this.$emit('update:content', vl)
            },
        },
        computed: {
            // 获取当前选中的分组名称
            groupName(){
                let name = ''
                options.map(v=>{
                    v.options.map(q=>{
                        if(q.value === this.newSelect){
                            name = v.label
                        }
                    })
                })
                return name
            }
        },
        created(){
            this.init()
        },
        data(){
            return {
                options,
                newSelect: this.select,
                newContent: this.content
            }
        },
        methods:{
            ...mapActions(['setSendKeyBoardToCocos', 'setQuestionBankConfig']),
            init(){
                // this.flashData()
            },
            // 设置选中学科
            async setSelectedSubject(subject_id, grade_id){
                // TODO 删除选中学科和年级时，默认提交小学语文？
                const res = await CommonServer.default.updateSelectedSubject({
                    subject_id: subject_id || '1',
                    grade_id: grade_id || '66'
                })
                if(res && res.status_code === 200){
                    this.setQuestionBankConfig({
                        subject_id,
                        grade_id
                    })
                }
            }
            // async flashData(){
                // const res = await CommonServer.default.queryGrades()
                // const gradeIndex = this.$utils.getIndexByAttr({attr: 'grade', data: this.form})
                // this.form[gradeIndex].options = res.data.map(v=>{
                //     return {
                //         label: '语文',
                //         key: v.id,
                //         value: v.name
                //     }
                // })

            // }
        },
    }
</script>

<style>
.el-select-dropdown.el-popper.group-select .el-select-group__wrap{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 0px;
    margin-top: 6px;
}
.el-select-dropdown.el-popper.group-select .el-select-group__title{
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    line-height: 14px;
    margin-right: 26px;
    position: relative;
}
.el-select-dropdown.el-popper.group-select .el-select-group__title:before{
    content: '';
    position: absolute;
    top: 0px;
    right: -16px;
    width: 1px;
    height: 14px;
    background-color: #E5E7EE;
}
.el-select-dropdown.el-popper.group-select .el-select-dropdown__item.hover{
    background-color: #FFF6E5;
    color: #e7622e;
}
.el-select-dropdown.el-popper.group-select .el-select-dropdown__item{
    padding: 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 4px;
    height: 22px;
    line-height: 22px;
    border-radius: 4px;
    font-size: 14px;
    color: #606266;
}
.el-select-dropdown.el-popper.group-select .el-select-group__wrap::after{
    display: none;
}
.el-select-dropdown.el-popper.group-select .el-select-group__wrap .el-select-group{
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
<style lang="scss" scoped>
.search-box .group /deep/ .el-input__prefix{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    margin-left: 10px;
}
.search-box .group /deep/ .el-input__inner{
    padding-left: 54px;
}
.search-box .group.fontLen3 /deep/ .el-input__inner{
    padding-left: calc(54px + 14px * 1)
}
.search-box .group.fontLen4 /deep/ .el-input__inner{
    padding-left: calc(54px + 14px * 2)
}
.search-box .group.fontLen5 /deep/ .el-input__inner{
    padding-left: calc(54px + 14px * 3)
}
.search-box .group.fontLen6 /deep/ .el-input__inner{
    padding-left: calc(54px + 14px * 4)
}
.search-box /deep/ .el-select-group__wrap{
    display: flex;
    flex-direction: row;
}
.search-box {
    display: flex;
    margin-top: 22px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;

    .select{
        width: 260px;
    }

    .search-value{
        margin-left: 16px;
    }
}
.search-form{
    display: flex;
    width: 100%;
    height: 52px;
    flex-direction: row;
    align-items: center;
}
.search-form /deep/ .component+.component{
    margin-left: 6px;
}
</style>
